import React, { Suspense, memo, useCallback, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "@/store/rootReducer";
import type { AppDispatch } from "@/store/store";
import { setSidebarOpen } from "@/store/slices/globalSlice";

import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary";
import Loader from "@/components/Loader/Loader";

import styles from "../DisPostLogin/DisPostLogin.module.scss";
import Sidebar from "../DisPostLogin/Components/Sidebar/Sidebar";
import Navbar from "../DisPostLogin/Components/Navbar/Navbar";




const PostLogin: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();

  // const sidebarOpen = useSelector(
  //   (state: RootState) => state.global.sidebarOpen
  // );

  // /**
  //  * Toggle sidebar open/close with event prevention
  //  */
  // const toggleSidebarOpen = useCallback(
  //   (flag: boolean) => () => {
  //     if (sidebarOpen !== flag) {
  //       dispatch(setSidebarOpen(flag));
  //     }
  //   },   
  //   [dispatch, sidebarOpen]
  // );

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };


  return (
    <div>
      <Navbar toggleSidebar={toggleSidebar}/>
     <div className={styles.layout}>
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
      
      <div className={styles .rightSideContainer}>
       
        <div className={styles.outletDiv} >
          <Suspense fallback={<Loader />}>
            <ErrorBoundary>
              <Outlet key={location.pathname} />
            </ErrorBoundary>
          </Suspense>
        </div>
      </div>
    </div>
    </div>
    
  );
};

export default memo(PostLogin);
